import styles from './index.less';
import Detail from '@/pages/RepairDetail/components/Detail';
import { useLocation, useModel, useNavigate } from '@umijs/max';
import RepairSteps from '@/pages/RepairDetail/components/RepairSteps';
import BottomButtons from '@/components/BottomButtons';
import { Dialog, Toast } from 'react-vant';
import { useEffect, useState } from 'react';
import { getTicketDetail, getTicketFlowDetail, withdrawnTicket } from '@/service/repaire';
import { message } from 'antd';

const RepairDetail = () => {
  const location = useLocation();
  const sequenceNbr = new URLSearchParams(location.search).get('sequenceNbr');

  console.log('sequenceNbr', sequenceNbr)
  const [submitText, setSubmitText] =  useState<string>('撤销');
  const { editClick, refreshSend } = useModel('useRepair', (model) => ({
    editClick: model.editClick,
    refreshSend: model.refreshSend,
  }));
  const [flowList, setFlowList] = useState<Array<any>>([]);
  const [workOrderDetailItem, setWorkOrderDetailItem] = useState<{
    ticketStatus?:string
  }>({});

  useEffect(() => {
    getTicketDetail(sequenceNbr).then((res) => {
      if (res && res.code === 200) {
        setWorkOrderDetailItem(res.data || []);
      }
    });
    getTicketFlowDetail({ticketId: sequenceNbr}).then((res) => {
      if (res && res.code === 200) {
        setFlowList(res.rows || []);
      }
    });
  }, [sequenceNbr]);

  const handleCancelClick = () => {
    console.log('cancelClick');

  };

  
  const navigate = useNavigate();
  const handleSubmit = () => {
    console.log('submit');
    Dialog.confirm({
      title: '确认撤销',
      message: `确认撤销此工单？`,
      confirmButtonText: '确定',
      onCancel: () => console.log('cancel'),
      onConfirm: () => {
        withdrawnTicket(sequenceNbr).then(res => {
          if (res && res.code ===200) {
            Toast.success('撤销成功')
            navigate(-1); // 返回上一级
          }
        })
      },
    });
  };

  return (
    <div className={styles.container}>
      <Detail
        detailItems={workOrderDetailItem}
        editClick={editClick}
        cancelClick={handleCancelClick}
        refreshSendClick={refreshSend}
      />
      <RepairSteps status={workOrderDetailItem?.ticketStatus} flowList={flowList}/>
      {/* 待派单的工单可以撤销 */}
       {workOrderDetailItem?.ticketStatus === 'PENDING_DISPATCH' && <BottomButtons
      submitBtnText={submitText}
      submitBtnClick={handleSubmit}></BottomButtons>}
    </div>
  );
};

export default RepairDetail;


